<template>
  <div >
    <van-cell-group style="width: 100%">
      <van-cell  >

        <span  slot="title" class="wcc-icon wcc-icon-close1" @click="$emit('close')"
               style="font-size:16px; color:#43b292; padding: 0 10px;line-height: 18px;height: 18px"
        > </span>

        <span  slot="right-icon" class="wcc-icon wcc-icon-addpost" @click="addPost"
              style="margin-right:5px;font-size:11px;border-radius: 999px;color:#43b292;border: 1px solid #43b292;padding: 0 10px;line-height: 18px;height: 18px"
        > {{(refPid?'发布回复':'发布评论')}}</span>

<!--        <van-button slot="right-icon" plain hairline round icon="success" size="small"-->
<!--                    type="primary" color="#4bb0ff"  @click="addPost">{{(refPid?'发布回复':'发布评论')}}</van-button>-->
      </van-cell>
      <van-field
              v-model="content" ref="postContent"
              rows="5"
              autosize
              type="textarea"
              placeholder="请输入内容,至少8个字"
      />
      <van-uploader v-model="imgList" result-type="file" style="margin:10px"
                    :before-delete="delPic"
                    :after-read="afterRead"
                    :before-read = "beforeRead"
                    upload-text="添加图片"
      />
<!--      <div style="width: 100%;padding: 10px;text-align: center">-->

<!--        <van-button plain hairline icon="success"-->
<!--                    type="default"-->
<!--                    @click="addPost">发表</van-button>-->
<!--      </div>-->

    </van-cell-group>
  </div>
</template>

<script>
  import {Toast} from "vant"
export default {
  name: 'addPost',
  props: ["mid",'refPid'],
  data:function(){
    return {
      content:'',
      imgList:[]
    }
  },
  methods:{
    afterRead(file,detail){
      this.imgList.forEach(function(item){
        item.url = item.file.url;
      })
    },
    beforeRead:function(file,detail){
      var app = this;
      var formData = new FormData();
      var filename = file.name;
      formData.append('file',file,file.name)

      return app.axios.post("/bbsApi/uploadFile",formData,{
        headers: {'Content-Type': 'multipart/form-data1'}
      }).then(function(res){
        if(res.data.errcode=='suc'){
          var imgUrl = res.data.data.url;
          file.url = imgUrl;

          var textPos= app.$refs.postContent.$refs.input.selectionStart;
          app.content = app.content.substr(0,textPos) +'[图片:'+filename+']' + app.content.substr(textPos);

          return Promise.resolve();
        }
        else{
          return Promise.reject();
        }
      })



    },
    delPic:function(files,detail){

      var app = this;
      var tag = '[图片:'+ files.file.name+']';
      console.log("delPic",tag);
      app.content = app.content.replace(tag,'');

      return Promise.resolve();
      // return new Promise(function(resolve,reject){
      //     return resolve();
      // })
    },
      addPost:function(){
          var app = this;

        if(!app.content || app.content.length<8 ){
          Toast('填写内容,至少8个字');
          app.$refs.postContent.focus();
          return ;
        }

        var content = app.content;
        app.imgList.forEach(function(item){
          console.log("item",item);
          content = content.replace('[图片:'+item.file.name+']','<img src="'+item.url+'" style="max-width: 80%">')
        });


          app.axios.post("/bbsApi/addPost",{
              mid:app.mid,
              content:content,
              refPid: app.refPid
          })
              .then(function(res){
                  if(res.data.errcode=="suc"){
                      app.content = '';
                      app.imgList.splice(0)
                      app.$emit("closeBack",res.data.data)
                  }
                  else if(res.data.errcode=='need-phone'){

                  }
              })
      },
  },
  mounted() {
    this.axios.get("/checkPhone");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .van-uploader__upload-text{
    color:#43b292;
    font-size: 12px;
  }
  .van-uploader__upload-icon{
    color:#43b292;
  }
  .van-icon-plus:before{
    font: 14px/1 "FontAwesome";
    font-size: 18px;
    content: "\f0fe"
  }
</style>
